import imageCompression from "browser-image-compression";
import exifr from "exifr";

export async function dataPicture(key, imgInfo, profile, currentUser, heicFile, avatar) {

  const metaData = await exifr.parse(avatar, [
        "GPSLatitudeRef",
        "GPSLongitudeRef",
        "CreateDate",
        "ModifyDate",
        "GPSLatitude",
        "GPSLongitude",
        "DeviceSettingDescription",
        "FileSource",
        "GPSAltitude",
        "GPSAltitudeRef",
        "GPSDateStamp",
        "GPSProcessingMethod",
        "GPSTimeStamp",
        "GPSVersionID",
        // 'Make',
        // 'Model',
    ]);

    // Picture Data
  const picture: any = {
        key,
        metaData,
        uploadLatitude: imgInfo.uploadLatitude,
        uploadLongitude: imgInfo.uploadLongitude,
        profile,
        user: currentUser,
        picturePathFn: (_name) => `/api/files/keys/${key.id}/pictures/${_name}`,
    };
    // Picture compression
  const options = {
      maxSizeMB: 1,
      preserveExif : true,
    };
  let compressedFile: any = null;
  if (!heicFile) {
        compressedFile = await imageCompression(avatar, options);
    }
  const formData = new FormData();
  formData.append("file", compressedFile ? compressedFile : heicFile);
  formData.append("fileName", avatar.name);

  const data: any = {
        formData,
        picture,
    };
  return data;
}
